import { ART, JEWELRY } from "@/constant/routes";
import "./navbar.css";
import { NavLink } from "react-router-dom";
import Select, { type SelectItem } from "../select/Select";


interface NavbarProps {
    onClick?: () => void;
    displayName?: string;
    options?: SelectItem[];
    withNavLinks?: boolean;
 }

export default function NavBar({displayName, options, withNavLinks= true, ...props}: NavbarProps) {

    
    return (
        <header className="navbar">
            <div className="navbar-logo">
                <div className="navbar-logo-icon">
                    P
                </div>
                <div className="navbar-logo-text">
                    <span>Patrimoine</span>
                    <small>Management</small>
                </div>
            </div>
            {withNavLinks && <nav className="navbar-links">
                <NavLink to={ART}>Art</NavLink>
                <NavLink to={JEWELRY}>Bijoux</NavLink>
            </nav>}
            <div className="navbar-actions">
                {displayName && <Select label={displayName} items={options}/>}
            </div>
        </header>
    );

}